import { createBrowserHistory } from 'history';
import React, { useEffect, useRef, useState } from 'react';
import { Route, Router, Switch } from "react-router-dom";
import './app.less';
import { WaitLoaderFullScreen } from './components/Loader';
import { Breakdown } from './components/pages/Breakdown';
import { Outcomes } from './components/pages/Outcomes';
import { Splash } from './components/pages/Splash';
import { What } from './components/pages/What';
import { Who } from './components/pages/Who';
import { BottomNav } from './components/parts/BottomNav';
import { PageHeader } from './components/parts/PageHeader';
import { ScreenSmall } from './components/parts/ScreenSmall';
import { SideMenu } from './components/parts/SideMenu';
import { WhiteSkyHeader } from './components/WhiteSkyHeader';
import { TheBrain } from './data/brain';
import { defaultStore } from './data/dataStore';
import { loadRates } from './data/ppuRatesLoader';
import { getGenreBasedMixes } from './helpers';
import { NavPath } from './paths';
import { initialiseGA, trackCurrentPath } from './utils/googleAnalytics';

const App: React.FC = () => {

  const [data, setData] = useState(defaultStore);
  // const [data, setData] = useState(testStore);


  const [loading, setLoading] = useState(true);

  const history = useRef(createBrowserHistory());

  useEffect(() => {
    // initialise google analytics
    initialiseGA();

    // track page changes
    history.current.listen((location, action) => {
      trackCurrentPath();
    })
  }, [])




  const load = async () => {
    const rates = await loadRates();
    console.log({ rates });

    setData({
      ...data,
      rates: rates,
    });

    setLoading(false);
  }

  useEffect(() => { load() }, []);

  const brain = new TheBrain(data);

  return <div>
    <WhiteSkyHeader />
    <Router history={history.current}>
      <Switch>
        <Route path={NavPath.splash} exact >
          <Splash rates={data.rates} />
        </Route>
        <Route>
          <>
            <div className="show-small-screen">
              <ScreenSmall />
            </div>
            <div className="beom-app hide-small-screen">
              <div className="beom-sidemenu">
                <SideMenu brain={brain} />
              </div>
              <div className="beom-content">
                <div>
                  <div className="beom-header">
                    <PageHeader />
                  </div>
                  <div className="beom-info">
                    <Switch>
                      {/* <Route path={NavPath.splash} exact component={Splash} /> */}
                      <Route path={NavPath.who} exact >
                        <Who
                          data={data.info}
                          onChanged={d => {
                            const newData = { ...data };
                            if (data.info.genre != d.genre) {
                              // genre has changed... update the defaults
                              newData.breakEven = getGenreBasedMixes(d.genre)
                            }

                            setData({
                              ...newData,
                              info: d
                            })

                          }}
                        />
                      </Route>
                      <Route path={NavPath.what} exact >
                        <What
                          data={data.spend}
                          onChanged={d => setData({
                            ...data,
                            spend: d
                          })}
                          brain={brain}
                        />
                      </Route>
                      <Route path={NavPath.breakdown} exact >
                        <Breakdown
                          data={data.breakEven}
                          onChanged={d => setData({
                            ...data,
                            breakEven: d
                          })}
                          brain={brain}
                        />
                      </Route>
                      <Route path={NavPath.outcomes} exact>
                        <Outcomes
                          brain={brain}
                        />
                      </Route>
                    </Switch>
                  </div>
                </div>
                <div className="beom-bottomnav">
                  <BottomNav />
                </div>
              </div>
            </div>
            {loading && <WaitLoaderFullScreen message="Loading latest rates..." dark />}
          </>
        </Route>
      </Switch>
    </Router>
  </div>
}

export default App;
